import HTTP from '../HTTP';

function successNotificationHandler(response, successMessage) {
  if (successMessage !== false) {
    this.$notify({
      group: 'app',
      type: 'success',
      title: 'Erfolgreich',
      text: successMessage !== null && successMessage !== undefined
        ? successMessage
        : 'Die Änderungen wurden gespeichert.',
      duration: 3000
    })
  }

  return response;
}

function errorNotificationHandler(e, defaultErrorMessage) {
  if (defaultErrorMessage === false) {
    throw e;
  }

  const { response: { data } } = e;

  if (data.ui === true) {
    const { title, message, defaultError } = data;

    this.$notify({
      group: 'app',
      type: 'error',
      title,
      text: defaultErrorMessage !== false && defaultErrorMessage !== undefined && defaultError === true
        ? defaultErrorMessage
        : message,
      duration: 3000
    })
  }

  throw e;
}

export default {
  created() {
    this.HTTP = HTTP;
  },

  methods: {
    uiGet(url, defaultErrorMessage) {
      return this.HTTP.get(url)
        .catch(e => errorNotificationHandler.bind(this)(e, defaultErrorMessage))
    },
    uiPost(url, payload, successMessage, defaultErrorMessage) {
      return this.HTTP.post(url, payload)
        .then(response => successNotificationHandler.bind(this)(response, successMessage))
        .catch(e => errorNotificationHandler.bind(this)(e, defaultErrorMessage))
    },
    uiPatch(url, payload, successMessage, defaultErrorMessage) {
      return this.HTTP.patch(url, payload)
        .then(response => successNotificationHandler.bind(this)(response, successMessage))
        .catch(e => errorNotificationHandler.bind(this)(e, defaultErrorMessage))
    },
    uiDelete(url, successMessage, defaultErrorMessage) {
      return this.HTTP.delete(url)
        .then(response => successNotificationHandler.bind(this)(response, successMessage))
        .catch(e => errorNotificationHandler.bind(this)(e, defaultErrorMessage))
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/http.mixin.js